const NETWORK_MESSAGE = 'Cannot reach the server. Check your connection and try again.'

// Turns an axios rejection into a field -> message map the forms can render.
export const fieldErrors = (err) => {
  const errors = err?.data?.errors
  const fields = {}
  if (Array.isArray(errors)) {
    errors.forEach((item) => {
      if (item && item.param) fields[item.param] = item.msg
    })
  }
  return fields
}

export const errorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
  if (!err) return fallback
  if (err.status === 0) return NETWORK_MESSAGE

  const errors = err?.data?.errors
  if (Array.isArray(errors) && errors.length > 0) {
    const joined = errors.map((item) => item?.msg).filter(Boolean).join(' · ')
    if (joined) return joined
  }

  if (typeof err?.data === 'string' && err.data) return err.data
  if (err.status === 401) return 'Your session expired. Please log in again.'
  if (err.status === 404) return 'That item no longer exists.'

  return fallback
}
